import React, { useRef } from 'react';
import { useFieldAutoFocus, useFormValue } from '../common';
import { useFluidForm } from "../FormContext";
export function YesNoComponent({ fieldPath, options }) {
    let ref = useRef(null);
    let omitLabel = options?.omitLabel || false;
    const fluidForm = useFluidForm();
    const config = fluidForm.getFieldConfigByFieldPath(fieldPath);
    let [value, setValue] = useFormValue(fieldPath);
    useFieldAutoFocus(ref, fieldPath, options?.autoFocus);
    const handleBlur = () => {
        fluidForm.unfocusField(fieldPath);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex items-center " },
            React.createElement("input", { type: "checkbox", ref: ref, name: fieldPath, id: `ff-${fieldPath}`, "data-fieldname": fieldPath, className: "w-4 h-4 text-orange-500 border-gray-300 rounded focus:ring-orange-500 focus:ring-2", suppressContentEditableWarning: true, onFocus: (event) => {
                    fluidForm.setCurrentField(fieldPath);
                }, onChange: (event) => {
                    setValue(event.target.checked);
                }, onBlur: handleBlur, checked: Boolean(value) }),
            !omitLabel && (React.createElement("label", { htmlFor: `ff-${fieldPath}`, className: "ml-2 text-sm f-text-dark" }, config.label)))));
}
